

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTaskTitles } from "../redux/actions/tasksTitleActions";
import theme from "../components/shared/theme";
import {
  dropdownStyle,
  thStyle,
  tdStyle,
  paginationButtonStyle,
} from "../components/shared/themeStyles"; // ✅ Global styles import


const TasksTitle = () => {
  const dispatch = useDispatch();
  const { taskTitles, loading, error } = useSelector((state) => state.tasksTitle);

  useEffect(() => {
    dispatch(fetchTaskTitles());
  }, [dispatch]);

  return (
    <div style={{ backgroundColor: theme.colors.background, padding: theme.spacing.md, minHeight: "100vh" }}>
      <h1 style={{ fontSize: theme.font.size["2xl"], fontWeight: theme.font.weight.bold, marginBottom: theme.spacing.md }}>
        Task Titles
      </h1>

      {loading ? (
        <p style={{ fontSize: theme.font.size.base }}>Loading task titles...</p>
      ) : error ? (
        <div
          style={{
            backgroundColor: theme.colors.dangerLight,
            border: `1px solid ${theme.colors.danger}`,
            color: theme.colors.dangerText,
            padding: theme.spacing.sm,
            borderRadius: theme.radius.md,
          }}
        >
          Error: {error}
        </div>
      ) : (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[600px] w-full text-sm text-left">
            <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Title</th>
                <th style={thStyle}>Priority</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {taskTitles.map((task, index) => (
                <tr key={task.id || index} className="hover:bg-gray-50">
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{task.title}</td>
                  <td style={tdStyle}>{task.priority}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TasksTitle;
